import React from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit.sass"

import Popup from "../../../components/Popup";
import notifyUser from "../../../methods/notifyUser";
import {connect} from "react-redux";
import ApiKeyField from "../../../components/ApiKeyField";
import {
    YCLIENTS_MARKETPLACE_ABOUT,
    YCLIENTS_MARKETPLACE_URL,
} from "./yclientsMarketplaceCopy";

type Props = {
    close: Function,
    $store: any,
    $commitToStore: Function,
}

let YclientsIntegrationPopup: any = function YclientsIntegrationPopup(props: Props) {
    function onCopy() {
        notifyUser(props, "Ключ скопирован. Вставьте его во вкладке настроек приложения ОкиДоки в YCLIENTS");
    }

    function apiKey() {
        return `${props.$store.userSession.realty_api_key}`
    }

    return <Popup
        maxWidth="650px"
        onClose={() => {
            props.close()
        }}
    >
        <div>
            <div className="commonTitle" style={{marginBottom: 16}}>
                Интеграция с YCLIENTS
            </div>
            <div className="commonSubtitle" style={{marginBottom: 24, lineHeight: '1.6'}}>
                {YCLIENTS_MARKETPLACE_ABOUT}
            </div>

            <div className="commonLabel" style={{marginBottom: 16}}>
                Как подключить
            </div>
            <ol style={{marginBottom: 24, paddingLeft: 20, lineHeight: '1.8'}}>
                <li style={{marginBottom: 8}}>
                    Откройте приложение в маркетплейсе YCLIENTS и нажмите «Подключить»
                </li>
                <li style={{marginBottom: 8}}>
                    Во вкладке настроек вставьте API-ключ ОкиДоки (поле ниже)
                </li>
                <li style={{marginBottom: 8}}>
                    Чтобы в договор попали email и доп. поля карточки, укажите User Token
                    из кабинета разработчика: приложение ОкиДоки → <strong>Доступ к API</strong>.
                    Это не Partner Token из «Настройки аккаунта»
                </li>
                <li style={{marginBottom: 8}}>
                    При «Подключить» нажмите «Продолжить»: в «Доступ к разделам» должна быть
                    {' '}<strong>клиентская база</strong>. Если права включили позже —
                    отключите ОкиДоки в филиале и подключите снова
                </li>
                <li>
                    Сохраните. В карточке клиента в окне записи 2.0 появится вкладка ОкиДоки
                </li>
            </ol>

            <hr className="newHR"/>

            <div className="Body_15" style={{textAlign: "left", marginBottom: 16}}>
                Скопируйте API-ключ и вставьте его в настройках приложения ОкиДоки в YCLIENTS:
            </div>
            <div>
                <ApiKeyField
                    title="API-ключ ОкиДоки"
                    value={apiKey()}
                    onCopy={onCopy}
                />
            </div>

            <hr className="newHR"/>

            <div style={{display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 8}}>
                <a
                    href={YCLIENTS_MARKETPLACE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="new withTitle _wa"
                    style={{display: 'inline-block', textAlign: 'center'}}
                >
                    Открыть в маркетплейсе YCLIENTS
                </a>
                <button
                    className="new withTitle secondary _wa"
                    onClick={() => {
                        props.close()
                    }}
                >
                    <div className="buttonsContainer">
                        <span>Закрыть</span>
                    </div>
                </button>
            </div>
        </div>
    </Popup>
}

YclientsIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(YclientsIntegrationPopup)

export default YclientsIntegrationPopup
